import { render, staticRenderFns } from "./StatusMapping.vue?vue&type=template&id=27ca545e&scoped=true&"
import script from "./StatusMapping.vue?vue&type=script&lang=ts&"
export * from "./StatusMapping.vue?vue&type=script&lang=ts&"
import style0 from "./StatusMapping.vue?vue&type=style&index=0&id=27ca545e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca545e",
  null
  
)

export default component.exports